// custom scripts

document.addEventListener('DOMContentLoaded', function () {
  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  document.querySelectorAll('.reveal').forEach(function (el) {
    revealObserver.observe(el);
  });
});

// Header scroll state — toggles "header--scrolled" past ~50px of scroll.
// Reads scroll position from whichever element actually scrolls (`.page-wrapper`
// is the real scroll element on desktop >=990px, since <html>/<body> are
// overflow:hidden there — see assets/scroll-container.js; native document
// scroll on mobile), throttled to at most once per animation frame.
(function () {
  var header = document.getElementById('header-component');
  if (!header) return;

  var desktopQuery = window.matchMedia('(min-width: 990px)');
  var threshold = 50;
  var ticking = false;
  var target = null;

  function getScrollTop() {
    if (desktopQuery.matches) {
      var wrapper = document.querySelector('.page-wrapper');
      return wrapper ? wrapper.scrollTop : window.scrollY;
    }
    return window.scrollY || document.documentElement.scrollTop;
  }

  function update() {
    ticking = false;
    header.classList.toggle('header--scrolled', getScrollTop() > threshold);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  function bind() {
    if (target) target.removeEventListener('scroll', onScroll);
    target = desktopQuery.matches ? document.querySelector('.page-wrapper') || document : document;
    target.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  bind();
  desktopQuery.addEventListener('change', bind);
})();

// Ambient particles — "Únete a la manada" section. Generated dynamically
// (not hardcoded per-particle in HTML). Purely decorative: pointer-events
// stay none throughout (see custom.css), so clicks on .nl__btn are
// unaffected. Respects prefers-reduced-motion by rendering static
// (non-animated) specks instead of skipping them entirely.
document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('.nl');
  if (!section) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var count = 18;

  var container = document.createElement('div');
  container.className = 'nl__particles';
  container.setAttribute('aria-hidden', 'true');

  for (var i = 0; i < count; i++) {
    var particle = document.createElement('span');
    particle.className = 'nl__particle';

    var size = 3 + Math.random() * 5; // 3–8px
    var left = Math.random() * 100; // %
    var duration = 6 + Math.random() * 6; // 6–12s

    particle.style.width = size + 'px';
    particle.style.height = size + 'px';
    particle.style.left = left + '%';
    particle.style.background = Math.random() < 0.5 ? 'var(--color-accent)' : '#F7F2EA';

    if (reduceMotion) {
      particle.style.opacity = '0.18';
    } else {
      var delay = -1 * Math.random() * duration; // negative delay desyncs each particle's phase immediately
      particle.style.animationName = 'doppi-particle-rise';
      particle.style.animationDuration = duration + 's';
      particle.style.animationDelay = delay + 's';
    }

    container.appendChild(particle);
  }

  section.appendChild(container);
});

// "Momentos Doppi" carousel — reduced-motion + keyboard-focus pause.
// assets/slideshow.js (native, shared by every slideshow/announcement-bar
// on the theme) already pauses autoplay on mouseenter/mouseleave, but has
// no prefers-reduced-motion check and no focus handling — this fills just
// those two gaps, scoped to this one carousel instance only.
document.addEventListener('DOMContentLoaded', function () {
  var el = document.querySelector('[data-momentos-slideshow]');
  if (!el) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var whenReady = window.customElements && customElements.whenDefined
    ? customElements.whenDefined('slideshow-component')
    : Promise.resolve();

  whenReady.then(function () {
    if (reduceMotion) {
      // pause() (not suspend()) sets the durable `paused` state, so the
      // native resume() on a stray mouseleave/focusout is a no-op — this
      // autoplay stays off for good, only manual arrow/dot navigation works.
      el.pause();
      return;
    }

    el.addEventListener('focusin', function () {
      el.suspend();
    });
    el.addEventListener('focusout', function () {
      el.resume();
    });
  });
});
